import _ from 'lodash';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {selectAqfxNumber, toggleAqfxPanel} from '../actions';
import {aqfxServerBase} from '../config/environment';
import overlayConfig from '../config/overlays';
import './AerologicalImagePanel.css';

class AerologicalImagePanel extends Component {

  overlay_config = _.keyBy(overlayConfig, 'id')['AQFX'];
  image_url_template = `${this.overlay_config.config.base ||
                          aqfxServerBase}/${this.overlay_config.config.aerologicalImagesUrl}`;

  onClose = () => {
    this.props.dispatch(toggleAqfxPanel());
  };

  eatClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  onKeyDown = (event) => {
    if (event.keyCode === 27) {
      this.onClose();
    }
  };

  onNumberClick = (num) => {
    this.props.dispatch(selectAqfxNumber(num));
  };

  formatNumber = (num, width) => {
    return ('0000' + num).slice(-width);
  };

  imageUrl = () => {
    const { station_id, selected_number } = this.props;

    return this.image_url_template
               .replace('{stationId}', this.formatNumber(station_id, 4))
               .replace('{imageId}', this.formatNumber(selected_number - 1, 3));
  };

  componentDidMount() {
    document.addEventListener('keydown', this.onKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKeyDown, false);
  }

  render() {
    const { image_numbers, selected_number } = this.props;
    return (
      <div className="aerologicalImagePanel" onClick={this.onClose}>
        <div className="aerologicalImagePanel__content" onClick={this.eatClick}>
          <div className="close-button"><a onClick={this.onClose}>×</a></div>
          <div className="aerologicalImagePanel__top">
            <div className="image">
              <img src={this.imageUrl()} alt="Aerological Diagram"/>
            </div>
          </div>
          <div className="aerologicalImagePanel__bottom">
            {
              image_numbers.map((day, dayNum) => <div key={dayNum} className="aerologicalImagePanel__dayRow">
                  <span>Day {dayNum + 1}:</span>
                  {day.map((num, idx) =>
                    <a key={num}
                       className={'c-button light icon-only'.concat(selected_number === num ? ' selected' : '')}
                       onClick={() => this.onNumberClick(num)}>{idx + 1}</a>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }

}

const mapStateToProps = state => {
  return {
    image_numbers: state.aqfx.image_numbers,
    selected_number: state.aqfx.selected_number,
    station_id: state.aws.active.aqfxId
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch
  };
};

AerologicalImagePanel = connect(mapStateToProps, mapDispatchToProps)(AerologicalImagePanel);

export default AerologicalImagePanel;



// WEBPACK FOOTER //
// ./src/containers/AerologicalImagePanel.js